import React from "react";
import { toElementProps } from "../../Element";
import Embed, { EmbedStyles } from "./Embed.jsx";

export function BlockEmbedStyles(params = {}) {
    return {
        "& .block-embed": {
            display: "grid",
        },

        ...EmbedStyles(params),
    };
}

export default function BlockEmbed(props) {
    if (!props?.variables?.Embed) {
        return null;
    }

    const code = props.variables.Embed?.html;

    const elProps = toElementProps(props, { className: ["block-embed"] });

    return (
        <div {...elProps}>
            <Embed {...props} iframe={code} />
        </div>
    );
}
